export const DEFAULT_LANGUAGE = 'en'
export const LANGUAGE_STORAGE_KEY = 'fit3d_language'

export const SUPPORTED_LANGUAGES = [
  { code: 'en', shortCode: 'EN', flag: '🇺🇸', name: 'English' },
  { code: 'fr', shortCode: 'FR', flag: '🇫🇷', name: 'Français' },
  { code: 'de', shortCode: 'DE', flag: '🇩🇪', name: 'Deutsch' },
  { code: 'es', shortCode: 'ES', flag: '🇪🇸', name: 'Español' },
  { code: 'pt', shortCode: 'PT', flag: '🇵🇹', name: 'Português' },
  { code: 'zh_CN', shortCode: 'ZH_CN', flag: '🇨🇳', name: '汉语' },
  { code: 'zh_TW', shortCode: 'ZH_TW', flag: '🇹🇼', name: '漢語' },
  { code: 'it', shortCode: 'IT', flag: '🇮🇹', name: 'Italiano' },
  { code: 'ko', shortCode: 'KO', flag: '🇰🇷', name: '한국어' },
  { code: 'nl', shortCode: 'NL', flag: '🇳🇱', name: 'Nederlands' },
  { code: 'fi', shortCode: 'FI', flag: '🇫🇮', name: 'suomi' },
  { code: 'ru', shortCode: 'RU', flag: '🇷🇺', name: 'русский' },
  { code: 'sv', shortCode: 'SV', flag: '🇸🇪', name: 'Svenska' },
  { code: 'ja', shortCode: 'JA', flag: '🇯🇵', name: '日本語' },
  { code: 'tr', shortCode: 'TR', flag: '🇹🇷', name: 'Türkçe' },
  { code: 'cs', shortCode: 'CS', flag: '🇨🇿', name: 'čeština' },
  { code: 'el', shortCode: 'EL', flag: '🇬🇷', name: 'ελληνικά' },
  { code: 'hr', shortCode: 'HR', flag: '🇭🇷', name: 'Hrvatski' },
]

export const LANGUAGE_BY_CODE = SUPPORTED_LANGUAGES.reduce(
  (languages, language) => ({
    ...languages,
    [language.code]: language,
  }),
  {}
)

export const isSupportedLanguage = (language) => !!LANGUAGE_BY_CODE[language]

export const normalizeLanguage = (language) =>
  isSupportedLanguage(language) ? language : DEFAULT_LANGUAGE

export const getLanguage = (language) =>
  LANGUAGE_BY_CODE[normalizeLanguage(language)]
